<title>{{ disruptionNotificationsNdcTechnicalFaqPage.htmlTitle }}</title>
<app-banner [banner]="disruptionNotificationsNdcTechnicalFaqPage.banner"></app-banner>
<div class="container innerContent faq-disruption-notifications">
  <a [href]="BackLinkURL"><i [ngClass]="BackLinkIcon"></i>{{ BackLinkTitle }}</a>
  <app-border-section [param]="param" [sections]="disruptionNotificationsNdcTechnicalFaqPage.sections"></app-border-section>
</div>
